import { render, staticRenderFns } from "./InstallationActions.vue?vue&type=template&id=4a886edd&scoped=true"
import script from "./InstallationActions.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallationActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstallationActions.vue?vue&type=style&index=0&id=4a886edd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a886edd",
  null
  
)

export default component.exports